
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec148"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec148"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("f7Gm2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0285d2d543eead8$export$2e2bcd8739ae039);

var $7nhm9 = parcelRequire("7nhm9");
// VARIABLES
const $b0285d2d543eead8$var$colorTheme = {
    isLightTheme: true
};
const $b0285d2d543eead8$var$bodyElement = document.body;
const $b0285d2d543eead8$var$headerFont = document.querySelector(".header__font");
const $b0285d2d543eead8$var$headerToggleBtn = document.querySelector(".header__toggle-btn");
const $b0285d2d543eead8$var$headerToggleOval = document.querySelector(".header__toggle-oval");
const $b0285d2d543eead8$var$headerToggleRectangle = document.querySelector(".header__toggle-rectangle");
const $b0285d2d543eead8$var$headerMoonIconPath = document.querySelector(".header__moon-icon-path");
const $b0285d2d543eead8$var$formInput = document.querySelector(".form__input");
const $b0285d2d543eead8$var$spinner = document.querySelector(".spinner");
const $b0285d2d543eead8$var$notFoundText = document.querySelector(".not-found__text");
const $b0285d2d543eead8$var$headerFontStyles = document.querySelector(".header__font-styles");
const $b0285d2d543eead8$var$classesToToggle = [
    {
        element: $b0285d2d543eead8$var$bodyElement,
        className: "body--dark"
    },
    {
        element: $b0285d2d543eead8$var$headerFont,
        className: "dark"
    },
    {
        element: $b0285d2d543eead8$var$headerMoonIconPath,
        className: "header__moon-icon-path--dark"
    },
    {
        element: $b0285d2d543eead8$var$formInput,
        className: "form__input--dark"
    },
    {
        element: $b0285d2d543eead8$var$spinner,
        className: "spinner--dark"
    },
    {
        element: $b0285d2d543eead8$var$notFoundText,
        className: "dark"
    },
    {
        element: $b0285d2d543eead8$var$headerFontStyles,
        className: "header__font-styles--dark"
    }
];
// FUNCTIONS
function $b0285d2d543eead8$var$changeColorTheme() {
    // Change background of 'headerToggleRectangle' and change the position of 'headerToggleOval' depending on the color theme.
    $b0285d2d543eead8$var$headerToggleRectangle.classList.toggle("header__toggle-rectangle--dark");
    $b0285d2d543eead8$var$headerToggleOval.classList.toggle("header__toggle-oval--dark");
    // Change the boolean value of the 'isLightTheme' property to the opposite and update the colors based on the current color theme.
    $b0285d2d543eead8$var$colorTheme.isLightTheme = !$b0285d2d543eead8$var$colorTheme.isLightTheme;
    (0, $7nhm9.updateElementColors)($b0285d2d543eead8$var$classesToToggle);
}
(function() {
    // Check if the user prefers dark mode
    if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) // Change color theme to dark
    $b0285d2d543eead8$var$changeColorTheme();
})();
// EVENT LISTENER CALLBACK FUNCTION
function $b0285d2d543eead8$var$handleHeaderToggleBtnClick(e) {
    const headerToggleBtn = e.target.closest(".header__toggle-btn");
    if (!headerToggleBtn) return;
    // Change the color theme to light or dark.
    $b0285d2d543eead8$var$changeColorTheme();
}
// EVENT LISTENER
$b0285d2d543eead8$var$headerToggleBtn.addEventListener("click", $b0285d2d543eead8$var$handleHeaderToggleBtnClick);
var $b0285d2d543eead8$export$2e2bcd8739ae039 = $b0285d2d543eead8$var$colorTheme;

});


parcelRequire("f7Gm2");

//# sourceMappingURL=index.70561abb.js.map
